import type { LynxScanResultEvent } from '../native/advertiserDefinitions';
import type { ProximityBleBridge } from './bleBridge';

export type RawScanObservation = {
  deviceId: string;
  rssi: number;
  advertisedPeerId?: string;
};

export type BleScannerOptions = {
  bridge: ProximityBleBridge;
  onObservation: (observation: RawScanObservation) => void;
};

/**
 * Subscribes to native scanResult events and surfaces raw peer observations.
 */
export class BleScanner {
  private readonly bridge: ProximityBleBridge;
  private readonly onObservation: (observation: RawScanObservation) => void;
  private active = false;

  constructor(options: BleScannerOptions) {
    this.bridge = options.bridge;
    this.onObservation = options.onObservation;
  }

  get isActive(): boolean {
    return this.active;
  }

  async start(): Promise<void> {
    if (this.active) {
      return;
    }
    await this.bridge.startScanning((event: LynxScanResultEvent) => {
      this.handleScanResult(event);
    });
    this.active = true;
  }

  async stop(): Promise<void> {
    if (!this.active) {
      return;
    }
    await this.bridge.stopScanning();
    this.active = false;
  }

  private handleScanResult(event: LynxScanResultEvent): void {
    const rssi = event.rssi;
    if (rssi >= 0) {
      return;
    }
    const advertisedPeerId = event.userId && event.userId.length > 0 ? event.userId : undefined;
    this.onObservation({
      deviceId: event.deviceId,
      rssi,
      advertisedPeerId,
    });
  }
}
